import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import { DASHBOARD_BREAKPOINT_VALUES } from 'components/DashboardGrid/types';

export const DashboardWarningText = styled(KizenTypography)`
  max-width: 500px;
  text-align: center;
  padding-bottom: 0;
`;

export const DashboardErrorCodeText = styled(KizenTypography)`
  padding-top: 19px;
`;

export const BreakpointContainer = styled.div`
  margin: 0 auto;

  width: 100%;

  .bp {
    display: none;
  }

  .bp-container {
    color: white;
    position: fixed;
    top: 10px;
    left: 10px;
    background: black;
    border-radius: 5px;
    padding: 5px 10px;
  }

  @media screen and (min-width: ${DASHBOARD_BREAKPOINT_VALUES.XS}px) {
    width: ${DASHBOARD_BREAKPOINT_VALUES.XS + 1}px;

    .bp-xxs {
      display: block;
    }
  }

  @media screen and (min-width: ${DASHBOARD_BREAKPOINT_VALUES.XS + 80}px) {
    width: ${DASHBOARD_BREAKPOINT_VALUES.XS + 1}px;

    .bp-xs {
      display: block;
    }
  }

  @media screen and (min-width: ${DASHBOARD_BREAKPOINT_VALUES.SM + 80}px) {
    width: ${DASHBOARD_BREAKPOINT_VALUES.SM + 1}px;

    .bp-sm {
      display: block;
    }
  }

  @media screen and (min-width: ${DASHBOARD_BREAKPOINT_VALUES.MD + 80}px) {
    width: ${DASHBOARD_BREAKPOINT_VALUES.MD + 1}px;

    .bp-md {
      display: block;
    }
  }

  @media screen and (min-width: ${DASHBOARD_BREAKPOINT_VALUES.LG + 80}px) {
    width: ${DASHBOARD_BREAKPOINT_VALUES.LG + 1}px;

    .bp-lg {
      display: block;
    }
  }

  @media screen and (min-width: ${DASHBOARD_BREAKPOINT_VALUES.XL + 80}px) {
    width: ${DASHBOARD_BREAKPOINT_VALUES.XL + 1}px;

    .bp-xl {
      display: block;
    }
  }
`;
